import { Alignment } from "@redotech/redo-model/content-builder/element-schema";
import { starRatingWidgetParser } from "@redotech/redo-review-db-schema/star-rating-widget-schema";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

// Schema for the widget update input that omits the fields we don't want to allow updating
const starRatingWidgetUpdateFields = z.object({
  alignment: createEnum(Alignment),
  starPadding: z.number(),
  starSize: z.number(),
  emptyStarColor: z.string(),
  filledStarColor: z.string(),
  showStarsWhenNoReviews: z.boolean(),
  starOutlineEnabled: z.boolean(),
  starOutlineColor: z.string(),
  starOutlineWidth: z.number(),
});

export const updateStarRatingWidget = {
  name: "updateStarRatingWidget" as const,
  input: z.object({ id: z.string(), widget: starRatingWidgetUpdateFields }),
  output: starRatingWidgetParser,
};
